import * as Yup from 'yup';

const validationSchema = (renderContent) =>
  Yup.object({
    rsvNumber: Yup.string(
      renderContent('formBookingAmendErrorReservationNumber', 'Enter a valid reservation number'),
    )
      .matches(
        /^[0-9]*$/,
        renderContent(
          'formBookingAmendErrorReservationNumberRegex',
          'Enter a valid reservation number: 9999999',
        ),
      )
      .required(
        renderContent(
          'formBookingAmendReservationNumberRequired',
          'Reservation number is required',
        ),
      ),
    lastName: Yup.string(
      renderContent('formBookingAmendFieldLastName', 'Enter your last name'),
    ).required(renderContent('formBookingAmendRequiredLastName', 'Last name is required')),
  });

export default validationSchema;
